import {
  Backdrop,
  Badge,
  Box,
  Button,
  CircularProgress,
  Grid2,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import LanguageMenuItem from "../../components/SelectComponent/LanguageMenuItem";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { useTheme } from "@emotion/react";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MenuListCardsComponent from "./MenuListCardsComponent";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import footerImg from "../../assets/footerLogo.png";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import {
  updateDefaultLanguage,
  setLanguageData,
  setWebshopLoading,
  setOpenCart,
  setWebshopProductData,
  setIsProductLoading,
  setTotalVat,
  setTotalPrice,
  updateWebShopMenuPosition,
} from "../../store/slice/Webshop.slice";
import { useNavigate } from "react-router-dom";
import {
  updateButtonText,
  updateWidgetConfig,
} from "../../store/slice/widgetSetting.slice";
import { FetchWidgetConfigDetails } from "../../api/HorecaWidget.service";
import { format_Number, getCompanyStatus } from "../../utils/utils";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import RemoveShoppingCartOutlinedIcon from "@mui/icons-material/RemoveShoppingCartOutlined";
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
const MenuItemListComponent = () => {
  const { css } = useSelector((store) => store?.widgetSettings);
  const overAllCss=css?.find((item)=> item?.cssTabFieldsGroupName === "Overall" )?.fields
  const productScreen = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Prodcut list"
  )?.fields;
  const searchbar = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Search box"
  )?.fields;
  const btnCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "WebshopButton"
  )?.fields;
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { resType } = useSelector((store) => store?.widgetSettings);
  const {
    itemCount,
    webshopSettings,
    webShopMenuPosition,
    shopType,
    selectedMenuItem,
    webShopProductList,
    webShopProductInfo,
    itemCounts,
    supplementsInfo,
    languageData,
    defaultLanguage,
    webshopLoading,
    addToCartProducts,
    totalProductsCount,
    isProductLoading,
    languageWords,
    webshopOpeningHours,
    deliveryType,
  } = useSelector((store) => store?.Webshop);
  const openingShopHour = webshopOpeningHours?.value?.data?.openTime
    ?.split(":")
    .slice(0, 2)
    .join(":");
  const closingShopShopHour = webshopOpeningHours?.value?.data?.closeTime
    ?.split(":")
    .slice(0, 2)
    .join(":");

  const { key, widgetSetupId } = useSelector((store) => store?.widgetSettings);
  const [tempList, setTempList] = useState(webShopProductList);
  const [searchItem, setSearchItem] = useState("");

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchItem(searchTerm);
    if (searchTerm) {
      const filtered = webShopProductList?.filter((item) =>
        item?.displayname?.toLowerCase().includes(searchTerm?.toLowerCase())
      );
      setTempList(filtered);
    } else {
      setTempList(webShopProductList);
    }
  };

  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };

  const fetchWidgetSettingsDetails = async (lang) => {
    try {
      const response = await FetchWidgetConfigDetails(key, widgetSetupId, lang);
      if (response?.status != 200 || !response?.data) {
        throw new Error(
          "Failed to fetch widget settings details. Please try again later."
        );
      }
      const result = response?.data?.basicLanguages?.reduce((acc, item) => {
        const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
        const data = item.widgetTranslateLanguages[0]?.name;
        acc[tag] = data;
        return acc;
      }, {});
      dispatch(updateWidgetConfig(response?.data));
      dispatch(updateButtonText(response?.data?.fields?.reservationButtonText));
    } catch (error) {
      console.error("Error fetching widget settings details:", error);
    }
  };

  useEffect(() => {
    if (defaultLanguage) fetchWidgetSettingsDetails(defaultLanguage);
  }, [defaultLanguage]);
  useEffect(() => {
    if (resType !== "webshop") return;
    const cardContainer = document.getElementById("card-container");
    if (!cardContainer) return;
    if (tempList.length == 0) {
      send(`100vh`, "100%", "", "0px", "0px", "", "relative");
      return;
    }
    const observer = new ResizeObserver((entries) => {
      const height = entries[0].contentRect.height;
      const finalHeight = height + 200;

      send(`${finalHeight}px`, "100%", "", "0px", "0px", "", "relative");
    });

    observer.observe(cardContainer);

    return () => observer.disconnect();
  }, [resType, tempList]);

  useEffect(() => {
    setTempList(webShopProductList);
  }, [webShopProductList]);

  function CalculateVat(price, vatPersentage) {
    const vat = (price / (vatPersentage + 100)) * vatPersentage;

    return Math.round(vat * 100) / 100;
  }
  const isNullValue = (value) => value === null || value === "null";
  const calculateTotalPrice = (onlyVat = false) => {
    let vatAmount;
    const totalProductsPrice = addToCartProducts?.reduce((acc, product) => {
      const supplementInfo = supplementsInfo?.find(
        (item) => item?.idproduct === product.idproduct
      );
      const supplementTotal =
        supplementInfo?.supplements?.reduce(
          (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
          0
        ) || 0;
      const productTotal =
        (product.price + supplementTotal) * (itemCount[product.idproduct] || 0);
      vatAmount =
        onlyVat || webshopSettings?.pricesIncludingVAT
          ? CalculateVat(productTotal, product?.vat || 0)
          : 0;

      return acc + productTotal + vatAmount;
    }, 0);
    if (onlyVat) {
      dispatch(setTotalVat(vatAmount));
      return format_Number(vatAmount);
    }
    dispatch(setTotalPrice(totalProductsPrice));
    return format_Number(totalProductsPrice);
  };
  React.useEffect(() => {
    if (addToCartProducts?.length && Object.keys(itemCount || {}).length) {
      calculateTotalPrice();
      calculateTotalPrice(true);
    }
  }, [itemCount, addToCartProducts, supplementsInfo]);

  if (isProductLoading)
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={isProductLoading}
        onClick={() => dispatch(setIsProductLoading(false))}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );

  return (
    <div>
      {webShopMenuPosition == "null" &&
        !getCompanyStatus(
          webshopOpeningHours?.value?.data?.openTime,
          webshopOpeningHours?.value?.data?.closeTime,
          webshopOpeningHours?.value?.data?.companyOpen,
          webshopOpeningHours?.value?.data?.deliveryFrom,
          webshopOpeningHours?.value?.data?.deliveryTo,
          webshopOpeningHours?.value?.data?.delivery,
          deliveryType
        )?.status && (
          <Box
            sx={{
              width: "100%",

              backgroundColor: "#fff3f3",
              borderBottom: "1px solid #f44336",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
              py: 1.5,
            }}
          >
            <Typography
              sx={{
                color: "#c62828",
                fontWeight: 600,
                fontSize: "1.1rem",
                fontFamily: "Roboto, sans-serif",
                letterSpacing: "0.5px",
              }}
            >
              {
                getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.message
              }
            </Typography>
          </Box>
        )}

      <Box
        sx={{
          width: "100%",
          ml:
            webShopMenuPosition == "vertical"
              ? isSmallScreen
                ? "50px"
                : "80px"
              : 0,
          p: 1,
          minHeight: "100vh",
          backgroundColor: productScreen?.productListBg,
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            pt: 2,
          }}
        >
          <Box>
            {isSmallScreen ? (
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "0.6rem" }}
              >
                <Box>
                  <IconButton
                    color="warning"
                    onClick={() =>
                      navigate(
                        `/widget?widgetsetupid=${widgetSetupId}&key=${key}&resType=${resType}&position=${webShopMenuPosition}`
                      )
                    }
                    sx={{
                      backgroundColor: overAllCss?.backIconBg,
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                      "&:hover": {
                        backgroundColor: "#ffe082",
                      },
                    }}
                  >
                    <ArrowBackIosNewRoundedIcon color='black'
                      sx={{ fontSize: { xs: 20, sm: 24, md: 28 } }}
                    />
                  </IconButton>
                </Box>
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: productScreen?.productTitleTxtClr,
                  }}
                >
                  {selectedMenuItem?.name}
                </Typography>
              </Box>
            ) : webShopMenuPosition == "null" ? (
              <IconButton
                color="warning"
                onClick={() =>
                  navigate(
                    `/widget?widgetsetupid=${widgetSetupId}&key=${key}&resType=${resType}&position=${webShopMenuPosition}`
                  )
                }
                sx={{
                   backgroundColor: overAllCss?.backIconBg,
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  "&:hover": {
                    backgroundColor: "#ffe082",
                  },
                }}
              >
                <ArrowBackIosNewRoundedIcon
                  sx={{ fontSize: { xs: 20, sm: 24, md: 28 } }}
                />
              </IconButton>
            ) : (
              shopType != "kiosk" && (
                <Box>
                  <Box sx={{ mt: 2 }}>
                    <IconButton
                      color="warning"
                      onClick={() =>
                        navigate(
                          `/widget?widgetsetupid=${widgetSetupId}&key=${key}&resType=${resType}&position=${webShopMenuPosition}`
                        )
                      }
                      sx={{
                        backgroundColor:overAllCss?.backIconBg,
                        borderRadius: 2,
                        ml: 5,
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                        "&:hover": {
                          backgroundColor:overAllCss?.backIconHoverBg,
                        

                        },
                      }}
                    >
                      <ArrowBackIosNewRoundedIcon
                        sx={{ fontSize: { xs: 20, sm: 24, md: 28 },'&:hover':{
                          color:overAllCss?.backIconHoverText
                        } }}
                      />
                    </IconButton>
                  </Box>
                </Box>
              )
            )}
          </Box>

          <Box>
            {isSmallScreen ? (
              <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                <LanguageMenuItem
                  languageData={languageData}
                  updateLanguageData={setLanguageData}
                  defaultLanguage={defaultLanguage}
                  updateDefaultLanguage={updateDefaultLanguage}
                />
                <Badge
                  badgeContent={totalProductsCount}
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: "#fff",
                      color: "#000",
                      fontWeight: "bold",
                    },
                  }}
                >
                  <ShoppingCartIcon
                    sx={{ color: "orange", cursor: "pointer" }}
                    onClick={() => {
                      if (addToCartProducts?.length > 0) {
                        dispatch(setOpenCart(true));
                      }
                    }}
                  />
                </Badge>
              </Box>
            ) : shopType == "kiosk" ? (
              <LanguageMenuItem
                languageData={languageData}
                updateLanguageData={setLanguageData}
                defaultLanguage={defaultLanguage}
                updateDefaultLanguage={updateDefaultLanguage}
              />
            ) : (
              <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                {getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.status &&
                  webshopSettings?.showOpeningHours && (
                    <Typography
                      sx={{
                        color: getCompanyStatus(
                          webshopOpeningHours?.value?.data?.openTime,
                          webshopOpeningHours?.value?.data?.closeTime,
                          webshopOpeningHours?.value?.data?.companyOpen,
                          webshopOpeningHours?.value?.data?.deliveryFrom,
                          webshopOpeningHours?.value?.data?.deliveryTo,
                          webshopOpeningHours?.value?.data?.delivery,
                          deliveryType
                        )?.color,
                        fontWeight: "bold",
                      }}
                    >
                      {
                        getCompanyStatus(
                          webshopOpeningHours?.value?.data?.openTime,
                          webshopOpeningHours?.value?.data?.closeTime,
                          webshopOpeningHours?.value?.data?.companyOpen,
                          webshopOpeningHours?.value?.data?.deliveryFrom,
                          webshopOpeningHours?.value?.data?.deliveryTo,
                          webshopOpeningHours?.value?.data?.delivery,
                          deliveryType
                        )?.message
                      }
                    </Typography>
                  )}
                {getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.status && (
                  <Box
                    sx={{ display: "flex", gap: "1rem", alignItems: "center" }}
                  >
                    {!isSmallScreen && (
                      <TextField
                        variant="outlined"
                        name={"searchItem"}
                        value={searchItem}
                        placeholder={languageWords?.SearchHere}
                        onChange={handleSearchChange}
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <SearchIcon color={searchbar?.searchIconClr} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          backgroundColor: searchbar?.searchbgClr,
                          borderRadius: 2,
                          mr: 25,
                          color: searchbar?.searchTxtClr,

                          "& .MuiOutlinedInput-root": {
                            borderRadius: 4,
                            border: "none",
                            "& fieldset": {
                              border: "lightgrey",
                            },
                            "&:hover fieldset": {
                              border: "lightgrey",
                            },
                            "&.Mui-focused fieldset": {
                              border: "lightgrey",
                            },
                          },
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: "5px",
                        backgroundColor: btnCss?.ButtonBgClr,
                        "&:hover": {
                          backgroundColor: btnCss?.ButtonHoverClr,
                        },
                        cursor: "pointer",
                        position: "fixed", // 👈 key change
                        top: webShopMenuPosition == "horizontal" ? 150 : 20,
                        right: 10,
                        zIndex: 1300, // higher to stay above content/modals
                      }}
                      onClick={() => {
                        if (addToCartProducts?.length > 0) {
                          navigate(
                            !isNullValue(webShopMenuPosition)
                              ? "/webshopMenuItem/cartdetail"
                              : "/cartdetail"
                          );
                        }
                      }}
                    >
                      <Badge
                        badgeContent={totalProductsCount}
                        sx={{
                          "& .MuiBadge-badge": {
                            backgroundColor: btnCss?.countIndicatorBgClr,
                            color: btnCss?.countIndicatorTxtClr,
                            fontWeight: "bold",
                          },
                        }}
                      >
                        <ShoppingCartIcon
                          //  sx={{ color: "orange", cursor: "pointer"}}
                          sx={{
                            color: btnCss?.ButtonTxtClr,
                            fontSize: { xs: 35, sm: 55 }, // larger icon on mobile & desktop
                            cursor: "pointer",
                          }}
                        />
                      </Badge>
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Box>

        <Box sx={{ mt: 2, marginLeft: 8 }}>
          {!isSmallScreen && (
            <Typography
              sx={{
                fontSize: isSmallScreen ? "0.5rem" : "1.5rem",
                fontWeight: "600",
                color: "#00000",
              }}
            >
              {selectedMenuItem?.name}
            </Typography>
          )}
          {isSmallScreen && (
            <Typography
              sx={{
                color: getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.color,
                fontWeight: "bold",
              }}
            >
              {
                getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.message
              }
            </Typography>
          )}

          <Typography
            sx={{
              fontSize: isSmallScreen ? "10px" : "16px",
              color: productScreen?.productTitleInfoClr,
              whiteSpace: "normal",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              width: "90%",
            }}
          >
            {selectedMenuItem?.info}
          </Typography>
        </Box>

        <div id="card-container">
          {tempList?.length > 0 ? (
            <MenuListCardsComponent data={tempList} />
          ) : (
            <Box
              sx={{
                height:
                  updateWebShopMenuPosition == "vertical" ? "90vh" : "65vh",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
                background: "linear-gradient(180deg, #fffaf5 0%, #fff 100%)",
              }}
            >
              {/* Soft Orange Glow Background */}
              <Box
                sx={{
                  position: "absolute",
                  width: 400,
                  height: 400,
                  background:
                    "radial-gradient(circle, rgba(255,138,0,0.25) 0%, transparent 70%)",
                  filter: "blur(40px)",
                  zIndex: 0,
                }}
              />

              {/* Floating Icon */}
              <Box
                sx={{
                  width: 140,
                  height: 140,
                  borderRadius: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    "linear-gradient(135deg, #ff8a00 0%, #ff5e00 100%)",
                  boxShadow: "0 20px 60px rgba(255,94,0,0.4)",
                  mb: 4,
                  zIndex: 1,
                  animation: "float 3s ease-in-out infinite",
                  "@keyframes float": {
                    "0%": { transform: "translateY(0px)" },
                    "50%": { transform: "translateY(-15px)" },
                    "100%": { transform: "translateY(0px)" },
                  },
                }}
              >
                <RemoveShoppingCartOutlinedIcon
                  sx={{
                    fontSize: 60,
                    color: "#fff",
                  }}
                />
              </Box>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 800,
                  mb: 2,
                  zIndex: 1,
                  color: "#222222",
                }}
              >
                No Products Available
              </Typography>

              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: "1.1rem",
                  maxWidth: 500,
                  lineHeight: 1.7,
                  zIndex: 1,
                }}
              >
                This category is currently empty. New items will be added soon.
                Please check back later.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  background: "linear-gradient(135deg, #ff8a00, #ff5e00)",
                  borderRadius: "50px",
                  px: 5,
                  py: 1.2,
                  textTransform: "none",
                  mt: 2,
                  fontWeight: 600,
                  boxShadow: "0 10px 25px rgba(255,94,0,0.3)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #ff7a00, #e65100)",
                  },
                }}
                onClick={() => {
                  setSearchItem("");
                  setTempList(webShopProductList);
                }}
              >
                Browse Menu
              </Button>
            </Box>
          )}

          <Grid2 container mt={4} sx={{ width: "100%", pb: 2 }}>
            {!webShopMenuPosition && (
              <Grid2 size={{ md: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <img
                    src={footerImg}
                    alt="footerLogo"
                    style={{ minWidth: "76px", height: "auto" }}
                  />
                </Box>
              </Grid2>
            )}
          </Grid2>
        </div>
        {tempList?.length > 0 && (
          <Box sx={{ position: "absolute", bottom: 10, left: 40 }}>
            <Typography
              sx={{ color: "#969BA0", textWrap: "wrap", marginLeft: 2 }}
            >
              {languageWords?.FooterInfo}
            </Typography>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default MenuItemListComponent;
